<div *ngIf="allWidgets.length"
     class="animated fadeIn">
    <div class="widgets-header">
        <h2 class="mx-0">{{ 'Widgets' }}</h2>
        <a class="btn btn-sm btn-icon m-0 p-0 ml-1"
           (click)="changeSort()">
            <mat-icon svgIcon="settings"></mat-icon>
        </a>
    </div>

    <div class="widgets-row p-relative">
        <div class="widget-list">
            <ng-container *ngFor="let mod of visibleWidgets">
                <div class="card add-hover"
                     (click)="doNavigation(mod)">
                    <div class="card-body d-flex align-content-start">
                        <img class="widget-img animated fadeIn"
                             [alt]="mod.title"
                             [src]="mod.image"/>
                        <div class="widget-text animated fadeIn">
                            <span class="total">{{ mod.total }}</span>

                            <span class="label d-block d-md-none d-lg-block font-weight-light">{{ mod.title }}</span>
                            <span class="label d-none d-md-block d-lg-none font-weight-light">{{ mod.shortTitle }}</span>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

        <div *ngIf="whichSet !== 'first'"
             class="widget-nav btn btn-outline-secondary p-2 rounded-circle left"
             (click)="decrementWidgets(this.whichSet)">
            <mat-icon svgIcon="arrow"></mat-icon>
        </div>

        <div *ngIf="whichSet !== 'last'"
             class="widget-nav btn btn-outline-secondary p-2 rounded-circle right"
             (click)="incrementWidgets(this.whichSet)">
            <mat-icon svgIcon="arrow"></mat-icon>
        </div>
    </div>
</div>
